import { Tab, Box, Tabs, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useOrderTabs } from '../hooks/use-order-tabs';

export function OrderTabsView({ tab }: { tab: string }) {
  const theme = useTheme();
  const { currentTab, TABS, handleChangeTab } = useOrderTabs({ initialTab: tab });

  return (
    <Stack
      flex={1}
      justifyContent="space-between"
      direction="row"
      sx={{
        borderBottom: 1,
        borderColor: theme.palette.background.neutral,
      }}
    >
      <Tabs value={currentTab} onChange={handleChangeTab}>
        {TABS.map((item) => (
          <Tab
            key={item.value}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>{item.label}</span>
                {item.badgeContent != null && item.badgeContent > 0 && (
                  <Box
                    sx={{
                      backgroundColor: 'primary.main',
                      color: 'white',
                      borderRadius: '50%',
                      minWidth: '20px',
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.75rem',
                      fontWeight: 'bold',
                    }}
                  >
                    {item.badgeContent}
                  </Box>
                )}
              </Box>
            }
            value={item.value}
          />
        ))}
      </Tabs>
    </Stack>
  );
}
